import { LoadingSpinner } from './loading-spinner'

export default function LoadingContainer() {
  return (
    <div className="flex items-center justify-center h-screen">
      <LoadingSpinner />
    </div>
  )
}
